var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "mt-1" }, [
    _c("div", { staticClass: "d-flex align-items-center" }, [
      _c(
        "div",
        { staticClass: "mr-2" },
        [
          _vm.characteristic.children.length > 0
            ? [
                _c(
                  "a",
                  {
                    staticClass: "color-black text-decoration-none",
                    attrs: { href: "#" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        _vm.showChilds = !_vm.showChilds
                      }
                    }
                  },
                  [
                    _c("Icon", {
                      attrs: {
                        icon: "caret-up",
                        rotate: _vm.showChilds ? 180 : 90
                      }
                    }),
                    _vm._v(
                      "\n\t\t\t\t\t" +
                        _vm._s(_vm.characteristic.label) +
                        "\n\t\t\t\t"
                    )
                  ],
                  1
                )
              ]
            : [
                _c(
                  "b-form-checkbox",
                  {
                    attrs: { checked: _vm.isChecked },
                    on: { change: _vm.onSelect }
                  },
                  [_vm._v(_vm._s(_vm.characteristic.label))]
                )
              ]
        ],
        2
      )
    ]),
    _vm._v(" "),
    _vm.showChilds
      ? _c(
          "div",
          { staticClass: "pl-4" },
          _vm._l(_vm.characteristic.children, function(child) {
            return _c("characteristic-tree-select-item", {
              key: child.id,
              attrs: {
                characteristics: _vm.characteristics,
                characteristic: child,
                parent: _vm.characteristic,
                selected: _vm.selected
              },
              on: {
                change: function($event) {
                  return _vm.$emit("change", $event)
                }
              }
            })
          }),
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }